import React, { Component } from "react";
import { revivalPhaseDay } from '../../../../utilities/churchRevival';
import { VictoryStack, VictoryScatter, VictoryTooltip, VictoryBar, VictoryLabel } from 'victory';
import pluralize from 'pluralize';

const REVIVAL_OFFSET = 5;
const width = 1000;
const height = 95;

const LineScatter = ({x, y}) => <text x={x - 2} y={y + 3} fill="#a4a4a4">|</text>;

export default class RevivalChart extends Component {
  get churchRevival() {
    return this.props.church.revival;
  }

  get revivalOffsetsData() {
    return [{ x: "", y: REVIVAL_OFFSET }];
  }

  get revivalPreparationCoordinate() {
    return REVIVAL_OFFSET + this.churchRevival.preparationDaysCount;
  }

  get revivalCoordinate() {
    return this.revivalPreparationCoordinate + this.churchRevival.revivalDaysCount;
  }

  get lineScatterCoordinates() {
    return([
      { x: REVIVAL_OFFSET, y: 0 },
      { x: this.revivalPreparationCoordinate, y: 0 },
      { x: this.revivalCoordinate, y: 0 }
    ]);
  }

  get currentRevivalPosition() {
    const revivalOffsetDays = revivalPhaseDay(this.churchRevival);

    switch(this.churchRevival.phase) {
      case 0:
        return revivalOffsetDays >= REVIVAL_OFFSET ? 0 : REVIVAL_OFFSET - revivalOffsetDays;
      case 1:
        return REVIVAL_OFFSET + this.churchRevival.preparationDaysCount - revivalOffsetDays;
      case 2:
        return this.revivalPreparationCoordinate + revivalOffsetDays;
      case 3:
        return revivalOffsetDays >= REVIVAL_OFFSET ? this.revivalCoordinate + REVIVAL_OFFSET : this.revivalCoordinate + revivalOffsetDays;
      default:
        break;
    }
  }

  get tooltipLabelText() {
    switch(this.churchRevival.phase) {
      case 0:
        return `${pluralize('Day', revivalPhaseDay(this.churchRevival), true)} to Event Preparation`;
      case 1:
        return `${pluralize('Day', revivalPhaseDay(this.churchRevival), true)} to Event`;
      case 2:
        return `Day ${revivalPhaseDay(this.churchRevival)} of Event`;
      case 3:
        return `Day ${revivalPhaseDay(this.churchRevival)} after Event`;
      default:
        break;
    }
  }

  labelPositionCoordinate(props) {
    const sum = REVIVAL_OFFSET * 2 + this.revivalCoordinate;
    return `-${props.y * 50 / sum}%`;
  }

  render() {
    return(
      <VictoryStack horizontal
                    height={height}
                    width={width}
                    colorScale={["#a8b2b3", "#4cd964", "#0093e5", "#a8b2b3"]}
                    style={{ data: { width: 4 }, labels: { fontSize: 10, fontWeight: "bold", fill: "#595959" } }}
      >
        <VictoryBar data={this.revivalOffsetsData}/>
        <VictoryBar
          labelComponent={<VictoryLabel dy={10} textAnchor="end" dx={(props) => this.labelPositionCoordinate(props)}/>}
          data={[{ x: "Event Preparation", y: this.churchRevival.preparationDaysCount }]}
          labels={(data) => (data.x)}
        />
        <VictoryBar
          labelComponent={<VictoryLabel dy={10} textAnchor="end" dx={(props) => this.labelPositionCoordinate(props)}/>}
          data={[{ x: "Event", y: this.churchRevival.revivalDaysCount }]}
          labels={(data) => (data.x)}
        />
        <VictoryBar data={this.revivalOffsetsData}/>
        <VictoryScatter dataComponent={<LineScatter/>} data={this.lineScatterCoordinates}/>
        <VictoryScatter
          events={[
            {
              target: "data",
              eventHandlers: {
                onMouseOver: () => {
                  return {
                    target: "labels",
                    mutation: (props) => {
                      return({ active: true, x: props.y });
                    }
                  };
                }
              }
            }
          ]}
          labelComponent={
            <VictoryTooltip
              horizontal={false}
              y={35}
              style={{fontSize: 8, fill: "#ffffff"}}
              flyoutStyle={{fill: "#404040", stroke: "#404040" }}
            />
          }
          style={{ data: { fill: "#0093e5" } }}
          size={8}
          data={[{ x: this.currentRevivalPosition, y: 0, label: this.tooltipLabelText }]}
        />
      </VictoryStack>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/overview/revivalChart.js